import React from "react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import loader from "../../../../assets/images/button-loader.svg"
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import Loader from "../../../../components/Loader/Loader";
import { Label } from "../../../../components/Label/Label";
import { BsQuestionCircle } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import HelperService from "../../../../utility/HelperService";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../components/Grid/Grid";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const headers: GridHeader[] = [
    {
        title: "Month",
        classTitle: 'text-start'
    },
    {
        title: "Complaints Year",
        class: 'text-center'
    },
    {
        title: "Count",
        class: "text-center"
    },



];
const Complaints = () => {
    const {
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [previousData, setpreviousData] = useState("");
    const [editorData, setEditorData] = useState<any>()
    const [rows, setRows] = useState<GridRow[]>([]);
    const [totalCount, setTotalCount] = useState("");
    const { state } = useLocation();
    let { id } = useParams();
    let history = useNavigate();
    useEffect(() => {

    }, []);
    const getList = (page: Number, searchText: string) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `/v2/Complaints/GetComplaintsPaginationList?page=${page}&keyword=${searchText}`,
        })
            .then((res: any) => {

                setTotalCount(res.total_count);
                setShowLoader(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i].month ? res.list[i].month : "-" });
                    columns.push({ value: res.list[i].year ? res.list[i].year : "-" });
                    res.list[i].year=res.list[i].year.toString();
                    columns.push({ value: actionList(res.list[i].month_in_number+res.list[i].year, res.list[i].count) });
                    rows.push({ data: columns });
                    // console.log(res.list[i].count);
                }
                setRows(rows);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };
    const actionList = (month: any, count: any) => {
        return (
            <>
                {/* <NavLink to="/Complaints-count" >{count}</NavLink> */}

                <a onClick={() => history(`/Complaints-count/${month}`, {
                    
                    
                })} className="action-btn cursor-pointer">
                     {count}
                </a>
                {/* <a onClick={() => history(`/Complaints-count/${month}`, {
                    
                    
                })}>
                     {count}
                </a> */}

            </>
        );
    };
    const onSorting = (currentPage: number, searchText: string) => {
        getList(currentPage, searchText)
    }
    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />

            <Loader show={ShowLoader} />
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div>
                        <h1 className="page-title">Complaints</h1>
                    </div>
                    <div className="text-right flex justify-end items-center">
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                        <NavLink to="/add-complaint" className="btn btn-brand btn-sm"> + Add</NavLink>
                    </div>
                </div>

                <div className="table-card">
                    <Grid
                        headers={headers}
                        rows={rows}
                        ShowLoader={ShowLoader}
                        errorMessage={"No Complaints Found"}
                        count={totalCount}
                        onPageChange={onSorting}
                        isShowSearch={true}
                    />
                </div>
            </div>

        </>
    )
}
export default Complaints;
